import Vapi from "vuex-rest-api";

const badwords = new Vapi({
  baseURL: "https://di-badwords-api.herokuapp.com/api/",
  state: {
    lists: []
  }
})
  .get({
    action: "getWordLists",
    property: "lists",
    path: "/lists"
  })
  .getStore();

export default badwords;
